import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import { COLORS } from "../../constants";
import { Tooltip, Zoom } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../..";

type LinkItem = {
  text: string;
  icon: JSX.Element;
  open: boolean;
  action: () => void;
};

type LinksProps = {
  settings: LinkItem[];
  showSolutions: boolean;
};

export const LinksMenu = ({ settings, showSolutions }: LinksProps) => {
  const selectObjectivesDialogOpen = useSelector((state: RootState) => state.dialogs.selectTopicsExamDialog);
  const selectExercisesDialogOpen = useSelector((state: RootState) => state.dialogs.selectExercisesExamDialog);
  const printDialogOpen = useSelector((state: RootState) => state.dialogs.printExamDialog);
  return (
    <>
      {settings.map((setting) => {
        let iconColor = "inherit";

        if (setting.text === "Lösungen anzeigen" && showSolutions) {
          iconColor = COLORS.DIDACTO_DARK_RED;
        }

        if (setting.text === "Kompetenzen auswählen" && selectObjectivesDialogOpen) {
          iconColor = COLORS.DIDACTO_DARK_RED;
        }

        if (setting.text === "Aufgaben hinzufügen" && selectExercisesDialogOpen) {
          iconColor = COLORS.DIDACTO_DARK_RED;
        }

        if (setting.text === "Drucken" && printDialogOpen) {
          iconColor = COLORS.DIDACTO_DARK_RED;
        }

        return (
          <Tooltip
            key={setting.text}
            title={setting.text}
            placement="right"
            arrow
            disableFocusListener
            slots={{
              transition: Zoom,
            }}
          >
            <ListItem disablePadding sx={{ display: "block" }} onClick={setting.action}>
              <ListItemButton
                sx={[
                  {
                    minHeight: 48,
                    px: 2.5,
                  },
                  setting.open
                    ? {
                        justifyContent: "initial",
                      }
                    : {
                        justifyContent: "center",
                      },
                ]}
              >
                <ListItemIcon
                  sx={[
                    {
                      minWidth: 0,
                      justifyContent: "center",
                      color: iconColor,
                    },
                    setting.open
                      ? {
                          mr: 3,
                        }
                      : {
                          mr: "auto",
                        },
                  ]}
                >
                  {setting.icon}
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </Tooltip>
        );
      })}
    </>
  );
};
